var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('div',[_c('top-bar'),_c('web-frame',{attrs:{"src":_vm.src}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }